const routeLoaders = {
  '/ai-chat': () => import('../pages/AIChatView'),
  '/ai-insights': () => import('../pages/AIInsights'),
  '/dashboard': () => import('../pages/Dashboard'),
  '/document-processing': () => import('../pages/DocumentProcessingView'),
  '/staged-records': () => import('../pages/StagedRecordsView'),
  '/grn-receiving': () => import('../pages/GrnReceivingView'),
  '/workflows': () => import('../pages/WorkflowsView'),
  '/erp-data': () => import('../pages/ErpDataView'),
  '/finance': () => import('../pages/FinanceCommandCenterView'),
  '/ap': () => import('../pages/APAgentView'),
  '/ap-workbench': () => import('../pages/APWorkbenchView'),
  '/collections': () => import('../pages/CollectionsView'),
  '/collections-workbench': () => import('../pages/CollectionsWorkbenchView'),
  '/rfq': () => import('../pages/RFQView'),
  '/supplier-payments': () => import('../pages/SupplierPaymentsView'),
  '/cashflow': () => import('../pages/CashFlowView'),
  '/customer-orders': () => import('../pages/CustomerOrdersView'),
  '/customer-support': () => import('../pages/CustomerSupportView'),
  '/whatsapp-sales': () => import('../pages/WhatsAppSalesView'),
  '/ops-dashboard': () => import('../pages/OperationsDashboard'),
  '/operations-control': () => import('../pages/OperationsControlCenter'),
  '/tasks': () => import('../pages/TasksView'),
  '/task-escalations': () => import('../pages/TaskEscalationsView'),
  '/sales-bot': () => import('../pages/SalesBotView'),
  '/communication': () => import('../pages/CommunicationAgentView'),
  '/modules': () => import('../pages/ModulesView'),
  '/organisation': () => import('../pages/TenantManagementView'),
  '/users': () => import('../pages/UserManagementView'),
  '/plan': () => import('../pages/PlanUsageView'),
  '/tenant-onboarding': () => import('../pages/TenantOnboardingView'),
  '/settings': () => import('../pages/SettingsView'),
  '/token-usage': () => import('../pages/TokenUsageView'),
};

const pendingPreloads = new Map();

export function preloadRoute(path = '') {
  const pathname = String(path).split('#')[0].split('?')[0];
  const loader = routeLoaders[pathname];
  if (!loader) return Promise.resolve();
  if (!pendingPreloads.has(pathname)) {
    pendingPreloads.set(pathname, loader().catch(() => pendingPreloads.delete(pathname)));
  }
  return pendingPreloads.get(pathname);
}
